// src/componentes/EditarCliente/EditarCliente.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../Firebase/firebaseconfig';
import './EditarCliente.css';
import { useUserContext } from '../GestionDeUsuarios/UserContext';
import AccessDenied from '../Auth/AccessDenied';
import { registrarAuditoria } from '../../helpers/auditoria';

const EditarCliente = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { can } = useUserContext();
  const [form, setForm] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    telefono: '',
    direccion: '',
    fechaNacimiento: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const cargarCliente = async () => {
      try {
        const docRef = doc(db, 'clientes', id);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          // Audit A-2: solo cargamos los 6 campos editables, no el spread
          // completo del doc. Si hacemos setForm(snap.data()) acabamos
          // sobrescribiendo timestamps, score, etiquetas y otros auxiliares
          // al submit.
          const d = snap.data() || {};
          setForm({
            nombre: d.nombre || "",
            apellidos: d.apellidos || "",
            email: d.email || "",
            telefono: d.telefono || "",
            direccion: d.direccion || "",
            fechaNacimiento: d.fechaNacimiento || "",
          });
        } else {
          setError('Cliente no encontrado');
        }
      } catch (err) {
        console.error(err);
        setError('Error al cargar datos');
      } finally {
        setLoading(false);
      }
    };
    cargarCliente();
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!can('clientes.editar')) return;
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      await updateDoc(doc(db, 'clientes', id), form);
      await registrarAuditoria({
        accion: 'clientes.editar',
        entidadTipo: 'cliente',
        entidadId: id,
        despues: form,
      });
      navigate(`/app/cliente/${id}`, { replace: true });
    } catch (err) {
      console.error(err);
      setError('Error al actualizar cliente');
      setIsSubmitting(false);
    }
  };

  if (loading) return <p>Cargando cliente...</p>;
  if (!can('clientes.editar')) {
    return <AccessDenied message="No tienes permiso para editar clientes." />;
  }

  return (
    <div className="editar-cliente-container">
      <h2>Editar Cliente</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="form-cliente">
        <input type="text" name="nombre" placeholder="Nombre" value={form.nombre} onChange={handleChange} required />
        <input type="text" name="apellidos" placeholder="Apellidos" value={form.apellidos} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} required />
        <input type="text" name="telefono" placeholder="Teléfono" value={form.telefono} onChange={handleChange} required />
        <input type="text" name="direccion" placeholder="Dirección" value={form.direccion} onChange={handleChange} required />
        <input type="date" name="fechaNacimiento" value={form.fechaNacimiento} onChange={handleChange} required />
        <div className="botones-editar">
          <button type="submit" disabled={isSubmitting} className="guardar-button">
            {isSubmitting ? "Guardando..." : "Guardar Cambios"}
          </button>
          <button
  type="button"
  className="cancelar-button"
  onClick={() => navigate(`/app/cliente/${id}`)}
>
  Cancelar
</button>
        </div>
      </form>
    </div>
  );
};

export default EditarCliente;
